import { deleteCookies, getCookieConsent, removeScript } from 'cookie-consent'
import { isDataProtective } from 'data-protective-check'

declare global {
  interface Window {
    dataLayer?: unknown[]
    LanguageModel?: { availability(): Promise<string> }
  }
}

const DEFAULT_SCRIPT_ID = 'gaScript'

let _gaTrackingId = ''
let _gaScriptId = DEFAULT_SCRIPT_ID
let _cookieName = ''

const noop = function () {
  /* intentionally empty */
}

export function initTracking({
  gaTrackingId,
  gaScriptId = DEFAULT_SCRIPT_ID,
  cookieName,
}: {
  gaTrackingId: string
  gaScriptId?: string
  cookieName: string
}) {
  _gaTrackingId = gaTrackingId
  _gaScriptId = gaScriptId
  _cookieName = cookieName

  if (getCookieConsent(_cookieName) !== false) {
    loadMinimalGAScript().catch((e) => console.error(e))
  }

  if (!isDataProtective() || getCookieConsent(_cookieName)) {
    acceptTracking()
  } else if (isDataProtective() && getCookieConsent(_cookieName) === false) {
    denyTracking()
    deleteCookies(['_ga', '_gid', '_gat'])
    delete window.dataLayer
    delete window.minimalAnalytics
  }
}

const _track = function (
  ...args: [string, string, Record<string, string | number>?]
) {
  if (typeof window !== 'undefined') {
    // @ts-expect-error window.__DEBUG_TRACK__
    if (window.__DEBUG_TRACK__ === true) {
      console.log('track', args)
    }
    if (args[0] === 'event') {
      const extendedEventData = {
        ...args[2],
      }
      if (window.track) {
        window.track(_gaTrackingId, {
          type: args[1],
          event: extendedEventData,
        })
      }
    }
  }
}

export function track(
  ...args: [string, string, Record<string, string | number>?]
) {
  const fn =
    isDataProtective() !== true || getCookieConsent(_cookieName) !== false
      ? _track
      : noop
  fn(...args)
}

export async function loadMinimalGAScript() {
  window.minimalAnalytics = {
    trackingId: _gaTrackingId,
    defineGlobal: true,
  }
  return import('@minimal-analytics/ga4').then(() => {
    if (window.track) {
      window.track(_gaTrackingId)
      window.track(_gaTrackingId, {
        type: 'page_view',
        event: {
          'ep.prefers_color_scheme': window.matchMedia(
            '(prefers-color-scheme: dark)',
          ).matches
            ? 'dark'
            : window.matchMedia('(prefers-color-scheme: light)').matches
              ? 'light'
              : 'none',
          'ep.prompt_api': 'LanguageModel' in window ? 'yes' : 'no',
        },
      })
    }
    window.LanguageModel?.availability()
      .then((availability) => {
        if (window.track) {
          window.track(_gaTrackingId, {
            type: 'prompt_api_availability',
            event: { 'ep.availability': availability },
          })
        }
      })
      .catch(() => {
        /* API present but unavailable */
      })
  })
}

export function acceptTracking() {
  if (!document.getElementById(_gaScriptId)) {
    loadMinimalGAScript().catch((e) => console.error(e))
  }
}

export function denyTracking() {
  removeScript(_gaScriptId)
}
